import { useTranslation } from "react-i18next";
import React from "react";
import { CONTACT_IMG } from "../../lib/assets";

export const ContactAreaInner = () => {
  const { t } = useTranslation();
  return (
    <section className="inner-contact-area pt-120 pb-120">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="inner-contact-img">
              <img src={CONTACT_IMG} alt="" />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="inner-contact-info">
              <h2 className="title">{t("contact.officeTitle")}</h2>
              <div className="contact-info-item">
                <h5 className="title-two">{t("contact.colombia")}</h5>
                <ul className="list-wrap">
                  {/* <li>
                    Calle 100, Suite 700 Santa <br />
                    Bogotá, Colombia
                  </li> */}
                  <li>+57 304 408 9089</li>
                  <li>info@caomei.com.co</li>
                </ul>
              </div>
              {/* <div className="contact-info-item">
                <h5 className="title-two">Oficina en USA</h5>
                <ul className="list-wrap">
                  <li>
                    Calle 100, Suite 700 Santa <br />
                    Monica, CA 90401, USA
                  </li>
                  <li>+57 304 408 9089</li>
                  <li>info@gmail.com</li>
                </ul>
              </div>
              <div className="contact-info-item">
                <h5 className="title-two">Oficina en China</h5>
                <ul className="list-wrap">
                  <li>
                    Calle 100, Suite 700 Santa <br />
                    Shangai, China
                  </li>
                  <li>+86 (310) 620-8565</li>
                  <li>info@gmail.com</li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
